import {assign, fromPromise, setup} from 'xstate';
import {jwtDecode} from "jwt-decode";

const fetchTokenActor = fromPromise(async ({input}) => {
    try {
        const token = await input.getAccessTokenSilently();
        console.log('=== ACCESS TOKEN DEBUG ===');
        console.log('Raw token:', token);
        
        // Decode and log the token contents
        try {
            const decoded = jwtDecode(token);
            console.log('Decoded token payload:', decoded);
            console.log('Token scopes:', decoded?.scope);
            console.log('Token audience:', decoded?.aud);
            console.log('Token issuer:', decoded?.iss);
            console.log('Token expires:', new Date(decoded?.exp * 1000));
        } catch (decodeError) {
            console.error('Failed to decode token for logging:', decodeError);
        }
        console.log('=== END TOKEN DEBUG ===');
        
        return token;
    } catch (error) {
        console.error('Error fetching token:', error);
        throw error;
    }
});
export const tokenMachine =
    setup({
        actors: {
            fetchTokenActor
        }
    }).createMachine({
        id: 'tokenMachine',
        initial: 'checking',
        context: ({input}) => {
            console.log('Token machine input:', input);
            return ({
                accessToken: null,
                isLoaded: false,
                isAuthenticated: false,
                isAdmin: false,
                getAccessTokenSilently: input.getAccessTokenSilently || null
            })
        },
        states: {
            idle: {
                on: {
                    REFRESH: 'checking'
                }
            },
            checking: {
                invoke: {
                    src: 'fetchTokenActor',
                    input: ({context}) => ({getAccessTokenSilently: context.getAccessTokenSilently}),
                    onDone: {
                        target: 'idle',
                        actions: assign(({event}) => {
                            const isAdmin = event.output != null ? applyToken(event.output) : false;
                            console.log('isAdmin:', isAdmin);

                            // Store successful login timestamp
                            if (event.output) {
                                localStorage.setItem('last_login_time', Date.now().toString());
                            }

                            return {
                                accessToken: event.output,
                                isAuthenticated: true,
                                isLoaded: true,
                                isAdmin
                            };
                        })
                    },
                    onError: {
                        target: 'idle',
                        actions: assign(({event}) => {
                            console.error('Error during token refresh:', event.error);
                            return {
                                accessToken: null,
                                isAuthenticated: false,
                                isLoaded: true
                            };
                        })
                    }
                }
            }
        }
    });

function applyToken(token) {
    try {
        const decoded = jwtDecode(token);
        console.log('Decoded token:', decoded);
        if (decoded?.scope) {
            const scopes = decoded.scope.split(' ');
            return scopes.includes('site:admin');
        } else {
            return false;
        }
    } catch (err) {
        console.error('Error decoding JWT', err);
        return false;
    }
}